export const INDUSTRY = {
  communications: '通信・ネットワーキング',
  computer_hardware: 'コンピューター - ハードウェア',
  computer_services: 'コンピューター - ITサービス',
  computer_software: 'コンピューター - ソフトウェア',
  semiconductors_electronics: '半導体/その他電子部品・製品',
  biotechnology: 'バイオテクノロジー',
  biotechnology_ict: 'バイオテクノロジー ICT',
  healthcare_related: '医療・ヘルスケア',
  healthcare_related_ict: '医療・ヘルスケア ICT',
  industrial_energy: '産業・エネルギー',
  industrial_energy_ict: '産業・エネルギー ICT',
  cleantechnology: '環境関連',
  cleantechnology_ict: '環境関連 ICT',
  retailing_media: '消費者向けサービス・販売',
  financial: '金融・保険・不動産',
  financial_ict: '金融・保険・不動産 ICT',
  business: 'ビジネスサービス',
}
